<script lang="ts">
import type { HTMLAttributes } from 'vue'
export interface GatFormFieldLabelProps {
  class?: HTMLAttributes['class']
  id?: string
  label?: string
  tooltipHint?: string
  showOptional?: boolean
  /** If the label should be shown in the warning color. */
  isWarning?: boolean
  /** If the label should be shown in the error color. */
  isError?: boolean
  /** If the label should be shown in the primary color. */
  highlightLabel?: boolean
}
</script>

<script setup lang="ts">
import { TooltipHint } from '../tooltips'
import FieldLabel from '../fields/FieldLabel.vue'
import { cn } from '../../lib/utils'

const props = defineProps<GatFormFieldLabelProps>()
</script>
<template>
  <FieldLabel :for="id ?? label" :class="props.class">

    <div class="flex items-end gap-0.5 leading-none" :class="cn({
      'text-primary': highlightLabel,
      'text-warning': isWarning,
      'text-error': isError,
    })">
      <slot>
        {{ label }}
      </slot>
      <TooltipHint icon-class="size-4" v-if="props.tooltipHint" :text="props.tooltipHint" />
    </div>
    <div class="flex items-end gap-0.5 leading-none">
      <span v-if="props.showOptional !== false" :class="[{ 'text-soft': !props.isError }, 'text-xs']">optional</span>
      <slot name="append" />
    </div>
  </FieldLabel>
</template>
